export default "71881:255:P, 72015:916:P, CONFIG.3870919, CONFIG.3780075, CONFIG.3805472\n";